export var RevenueCatWebhookEventType;
(function (RevenueCatWebhookEventType) {
    RevenueCatWebhookEventType["INITIAL_PURCHASE"] = "INITIAL_PURCHASE";
    RevenueCatWebhookEventType["NON_RENEWING_PURCHASE"] = "NON_RENEWING_PURCHASE";
    RevenueCatWebhookEventType["RENEWAL"] = "RENEWAL";
    RevenueCatWebhookEventType["PRODUCT_CHANGE"] = "PRODUCT_CHANGE";
    RevenueCatWebhookEventType["CANCELLATION"] = "CANCELLATION";
    RevenueCatWebhookEventType["UNCANCELLATION"] = "UNCANCELLATION";
    RevenueCatWebhookEventType["REFUND"] = "REFUND";
    RevenueCatWebhookEventType["SUBSCRIPTION_PAUSED"] = "SUBSCRIPTION_PAUSED";
    RevenueCatWebhookEventType["SUBSCRIPTION_EXTENDED"] = "SUBSCRIPTION_EXTENDED";
    RevenueCatWebhookEventType["EXPIRATION"] = "EXPIRATION";
    RevenueCatWebhookEventType["BILLING_ISSUE"] = "BILLING_ISSUE";
    RevenueCatWebhookEventType["INVOICE_ISSUANCE"] = "INVOICE_ISSUANCE";
    RevenueCatWebhookEventType["SUBSCRIBER_ALIAS"] = "SUBSCRIBER_ALIAS";
    RevenueCatWebhookEventType["SUBSCRIPTION_TRANSFERRED"] = "SUBSCRIPTION_TRANSFERRED";
    RevenueCatWebhookEventType["TEST"] = "TEST";
})(RevenueCatWebhookEventType || (RevenueCatWebhookEventType = {}));
//# sourceMappingURL=webhook-event-type.const.js.map